/**
 * Пути приложения
 *
 * Источник истины всех путей приложения, которые разрешает роутер
 */
export const AppPaths = {
    // Public
    ROOT: "/",
    AUTH: "/auth",
    MENU: "/menu",
    TASKS: "/tasks",
    SETTING: "/setting",
    THEME: "/theme",
    ABOUT_SYSTEM: "/about-system",

    // Fallback
    NOT_FOUND: "*",

    // Модуль "Учет в производстве"
    WORKSHOP: {
        INPLANTS: {
            LIST_TEMPLATE: "/:docType/ws-inplants",
            LIST: (docType: string) => `/${docType}/ws-inplants`,
            CARD_TEMPLATE: "/:docType/ws-inplants/:code",
            CARD: (docType: string, code: string) => `/${docType}/ws-inplants/${code}`,
        },
        INV_ACTS: {
            LIST: "/ws-inv-acts",
            CARD_TEMPLATE: "/ws-inv-acts/:code",
            CARD: (code: string) => `/ws-inv-acts/${code}`,
        },
        LIMIT_CARDS: {
            LIST: "/ws-limit-cards",
            CARD_TEMPLATE: "/ws-limit-cards/:code",
            CARD: (code: string) => `/ws-limit-cards/${code}`,
        },
        DEPOT: {
            LIST: "/ws-depot",
            CARD_TEMPLATE: "/ws-depot/:code",
            CARD: (code: string) => `/ws-depot/${code}`,
        },
    },

    // Модуль «Складской учёт» (заглушки дорожной карты)
    STOCK: {
        PLACEMENT: {
            LIST: "/stock/placement",
            CARD_TEMPLATE: "/stock/placement/:code",
            CARD: (code: string) => `/stock/placement/${code}`,
        },
        KANBAN_SUPPLY: {
            LIST: "/stock/kanban-supply",
            CARD_TEMPLATE: "/stock/kanban-supply/:code",
            CARD: (code: string) => `/stock/kanban-supply/${code}`,
        },
        PICKING_LISTS: {
            LIST: "/stock/picking-lists",
            CARD_TEMPLATE: "/stock/picking-lists/:code",
            CARD: (code: string) => `/stock/picking-lists/${code}`,
        },
        FG_RECEIPT: {
            LIST: "/stock/fg-receipt",
            CARD_TEMPLATE: "/stock/fg-receipt/:code",
            CARD: (code: string) => `/stock/fg-receipt/${code}`,
        },
        FG_SHIPMENT: {
            LIST: "/stock/fg-shipment",
            CARD_TEMPLATE: "/stock/fg-shipment/:code",
            CARD: (code: string) => `/stock/fg-shipment/${code}`,
        },
        FULL_INVENTORY: {
            LIST: "/stock/full-inventory",
            CARD_TEMPLATE: "/stock/full-inventory/:code",
            CARD: (code: string) => `/stock/full-inventory/${code}`,
        },
        PARTIAL_INVENTORY: {
            LIST: "/stock/partial-inventory",
            CARD_TEMPLATE: "/stock/partial-inventory/:code",
            CARD: (code: string) => `/stock/partial-inventory/${code}`,
        },
    },
} as const;

export type AppPath = keyof typeof AppPaths;
